import { ApiService } from "./api.service";
import { CommonService } from "./common.service";
import { ActivatedRoute, Router } from "@angular/router";
import { appRenameFixed } from "./appRenameFixed";
import { AbilityConfig } from "./ability-config/ability-config";
var LearningPathNewComponent = (function () {
    function LearningPathNewComponent(apiService, commonService, route, router) {
        this.apiService = apiService;
        this.commonService = commonService;
        this.route = route;
        this.router = router;
        this.appRename = new appRenameFixed();
        this.companyUrl = "";
        this.companyLogo = "";
        this.isShowTip = false;
        this.isShowQuestionnaire = false;
        this.questionnaireInfo = null;
        this.assetsRoute = "../../assets";
        this.desText = '由于升级系统，你需要重新完成<font color="#FFE258">能力诊断</font>，原本学习的数据已被<font color="#FFE258">保留</font>。';
    }
    LearningPathNewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.isShowBackBtn();
        this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
        window.sessionStorage.removeItem('newEdition');
        // this.getThirdCompany();
        this.mengban = false;
        this.sub = this.route.params.subscribe(function (params) {
            _this.learningPathMetaId = params['learningPathMetaId'];
        });
        //开始记录各能力学习时长
        // localStorage.setItem("learningPathMetaId",this.learningPathMetaId + "");
        // localStorage.setItem("learningPathMetaId-moduleId","-1");
        this.apiService.ajax({
            'type': 'GET',
            'url': '/sr/exposeoutapi/setAbilitySession/' + this.learningPathMetaId + '/-1'
        }).subscribe(function (result) { });
        this.getOrCreateLearningPath(this.learningPathMetaId).then(function (result) {
            _this.learningPath = result;
            _this.companyUrl = _this.learningPath.burl ? _this.learningPath.burl : "";
            _this.mode = _this.learningPath.subItems.length > 3 ? 1 : 2;
        }).then(function () {
            return _this.getUserQuestionnaireInfo(_this.learningPathMetaId).then(function (result) {
                return _this.questionnaireInfo = result;
            });
        }).then(function () {
            return _this.getUserStatus().then(function (result) {
                return _this.status = result;
            });
        }).then(function () {
            return _this.getUserInfo().then(function (result) {
                return _this.user = result;
            });
        }).then(function () {
            //满意度调查显示逻辑
            //获取到用户相应能力满意度 （questionnaireInfo长度为0 || questionnaireInfo长度大于0 && isShow不等于1） &&情景模拟完成了 && 后测没有完成
            _this.isShowQuestionnaire = _this.questionnaireInfo && (_this.questionnaireInfo.length === 0 || (_this.questionnaireInfo.length > 0 && _this.questionnaireInfo.filter(function (d) { return d.star === -1; }).length > 0)) && _this.learningPath.subItems[_this.getModuleIndex(4)].progress !== 100 && _this.learningPath.subItems[_this.getModuleIndex(3)].progress === 100 ? true : false;
            // this.isShowQuestionnaire = true;
            console.log(_this.isShowQuestionnaire);
            // 无后测版本逻辑
            // 是2019年6月18日以前注册的用户并且能力诊断未完成并且是之前完成过改课程的用户显示提示框
            _this.isShowTip = _this.compareDate("2019-06-18", _this.user.createdAt.split('T')[0]) && _this.learningPath.subItems[_this.getModuleIndex(1)].progress !== 100 && _this.learningPath.subItems[_this.getModuleIndex(2)].progress > 0 ? true : false;
        });
    };
    //查询用户相应能力满意度
    LearningPathNewComponent.prototype.getUserQuestionnaireInfo = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
        }).toPromise();
    };
    //获取模块位于learningPathSubItem里的下标
    LearningPathNewComponent.prototype.getModuleIndex = function (value) {
        return this.learningPath.subItems.map(function (item) { return item.type; }).indexOf(value);
    };
    // 根据learningPathMetaId创建或者获取LearningPath
    LearningPathNewComponent.prototype.getOrCreateLearningPath = function (learningPathMetaId) {
        return this.apiService.getOrCreateLearningPath(learningPathMetaId.toString()).toPromise();
    };
    //获取用户Status
    LearningPathNewComponent.prototype.getUserStatus = function () {
        return this.apiService.ajax({
            'type': 'post',
            'url': '/api/getUserInfo',
            'data': {}
        }).toPromise();
    };
    //获取用户信息
    LearningPathNewComponent.prototype.getUserInfo = function () {
        return this.apiService.getUserInfo().toPromise();
    };
    // 比较日期大小
    LearningPathNewComponent.prototype.compareDate = function (d1, d2) {
        var constDate = new Date(d1);
        var date = new Date(d2);
        return constDate.getTime() > date.getTime() ? true : false;
    };
    // 关闭问卷
    LearningPathNewComponent.prototype.closeQuestionnaire = function () {
        this.isShowQuestionnaire = false;
    };
    /* 获取第三方公司返回 */
    LearningPathNewComponent.prototype.isShowBackBtn = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'GET',
            'url': 'sr/exposeoutapi/getAbilityBack'
        }).subscribe(function (result) {
            _this.abilityBack = result.data.abilityBack;
        });
    };
    LearningPathNewComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    LearningPathNewComponent.prototype.goToLearningMap = function () {
        if (this.companyUrl) {
            if (this.companyUrl == "#") {
                return false;
            }
            else {
                location.href = this.companyUrl;
            }
        }
        else {
            var link = ['learning-map'];
            this.router.navigate(link);
        }
    };
    LearningPathNewComponent.prototype.hideTip = function () {
        $("#shade").fadeOut();
        $('#tip').fadeOut();
    };
    LearningPathNewComponent.prototype.hideTip2 = function () {
        $("#shade2").fadeOut();
        $('#tip2').fadeOut();
    };
    LearningPathNewComponent.prototype.try = function () {
        var link = ['form', '3'];
        this.router.navigate(link);
    };
    LearningPathNewComponent.prototype.mban = function () {
        if (this.status != 1) {
            console.log("点击");
            this.mengban = false;
        }
    };
    LearningPathNewComponent.prototype.shiyong = function () {
        this.mengban = false;
        var link = ['form', '3'];
        this.router.navigate(link);
    };
    LearningPathNewComponent.prototype.closeTip = function () {
        this.mengban = false;
    };
    LearningPathNewComponent.prototype.cardClick = function (i) {
        var type = this.learningPath.subItems[i].type;
        //开始记录各能力模块学习时长
        // localStorage.setItem("learningPathMetaId-moduleId",type + "");
        this.apiService.ajax({
            'type': 'GET',
            'url': '/sr/exposeoutapi/setAbilitySession/' + this.learningPathMetaId + '/' + type
        }).subscribe(function (result) { });
        if (type == 0) {
            this.showVector();
        }
        else if (type == 1) {
            this.showPreSurvey();
        }
        else if (type == 2) {
            this.showCourse();
        }
        else if (type == 3) {
            this.showPractice();
        }
        else if (type == 4) {
            this.showPostSurvey();
        }
    };
    LearningPathNewComponent.prototype.showVector = function () {
        if (this.status == 4 || this.status == 3) {
            var link = ['vector', this.learningPath.id];
            this.router.navigate(link);
        }
        else if (this.learningPath.currentItemIndex >= 0 && this.status == 1) {
            var link = ['vector', this.learningPath.id];
            this.router.navigate(link);
        }
    };
    LearningPathNewComponent.prototype.showPreSurvey = function () {
        var surveyMetaId, itemIndex;
        /* 进入新能力诊断标识 */
        var version = 0;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 1) {
                surveyMetaId = item.surveyMetaId;
                itemIndex = index;
                if (item.version) {
                    version = item.version;
                }
            }
        });
        // if(this.learningPath.currentItemIndex>=itemIndex&&this.status==1){
        if (this.learningPath.currentItemIndex >= itemIndex && this.status == 1 || (this.status == 4 || this.status == 3)) {
            if (this.learningPath.status == 0) {
                this.apiService.updateLearningPathStatus(this.learningPath.id).subscribe(function (result) {
                });
            }
            var link = ['survey', this.learningPath.id, surveyMetaId, 1];
            //影响力转向新能力检测
            if (version == 1) {
                link = ['ability-survey', this.learningPathMetaId, 1];
            }
            this.router.navigate(link);
        }
        else if (this.learningPath.currentItemIndex < itemIndex && this.status == 1) {
            $("#toast1").fadeIn(500, function () {
                setTimeout(function () {
                    $("#toast1").fadeOut(800);
                }, 800);
            });
        }
    };
    LearningPathNewComponent.prototype.showCourse = function () {
        var courseId, itemIndex;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 2) {
                courseId = item.id;
                itemIndex = index;
            }
        });
        if (this.status == 3 || this.status == 4) {
            var link = ['course', this.learningPath.id, courseId];
            this.router.navigate(link);
        }
        else {
            if (this.learningPath.currentItemIndex >= itemIndex || this.status != 1) {
                var link = ['course', this.learningPath.id, courseId];
                this.router.navigate(link);
            }
            else if (this.learningPath.currentItemIndex < itemIndex && this.status == 1) {
                $("#toast1").fadeIn(500, function () {
                    setTimeout(function () {
                        $("#toast1").fadeOut(800);
                    }, 800);
                });
            }
        }
    };
    LearningPathNewComponent.prototype.showPractice = function () {
        var practiceMetaId, practiceIndex;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 3) {
                practiceMetaId = item.practiceMetaId;
                practiceIndex = index;
            }
        });
        if (this.learningPath.currentItemIndex >= practiceIndex || this.status != 1) {
            //转向情景列表
            var link = this.abilityConfig.getPracticeLinkList(this.learningPath.name, this.learningPath.id, practiceMetaId);
            if (link.length > 0) {
                this.router.navigate(link);
            }
        }
        else if (this.learningPath.currentItemIndex < practiceIndex && this.status == 1) {
            $("#toast1").fadeIn(500, function () {
                setTimeout(function () {
                    $("#toast1").fadeOut(800);
                }, 800);
            });
        }
    };
    LearningPathNewComponent.prototype.showPostSurvey = function () {
        var surveyMetaId, itemIndex;
        /* 进入新能力诊断标识 */
        var version = 0;
        this.learningPath.subItems.forEach(function (item, index) {
            if (item.type == 4) {
                surveyMetaId = item.surveyMetaId;
                itemIndex = index;
                if (item.version) {
                    version = item.version;
                }
            }
        });
        // console.log(this.learningPath);
        if (this.learningPath.currentItemIndex >= itemIndex && this.status == 1) {
            var link = ['survey', this.learningPath.id, surveyMetaId, 1];
            //影响力转向新能力检测
            if (version == 1) {
                link = ['ability-survey', this.learningPathMetaId, 2];
            }
            this.router.navigate(link);
        }
        else if (this.learningPath.currentItemIndex < itemIndex && this.status == 1) {
            $("#toast1").fadeIn(500, function () {
                setTimeout(function () {
                    $("#toast1").fadeOut(800);
                }, 800);
            });
        }
    };
    LearningPathNewComponent.prototype.exitTip = function () {
        this.isShowTip = false;
    };
    return LearningPathNewComponent;
}());
export { LearningPathNewComponent };



// WEBPACK FOOTER //
// ./src/app/learning-path-new.component.ts.pre-build-optimizer.js